import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.5em", fontWeight: "600" }}>
              About <span className="purple">Me</span>
            </h1>
            <p className="home-about-body">
              I'm <b className="purple">Mohit Bokade</b>, an AI/ML enthusiast passionate about building intelligent systems and solving real-world problems with data.  
              <br />
              <br />
              With experience in <b className="purple">Power BI, Data Analyse and Machine Learning,</b>, I work on designing scalable models, fine-tuning <b className="purple">Machine Learning Models</b>, and optimizing data-driven applications.
              <br />
              <br />
              My tech stack includes:
              <i>
                <b className="purple"> Python, SQL, Power BI, Azure Data Factory</b>
              </i>.  
              I focus on ML/AI research, deep learning architectures, and making systems more efficient.  
              <br />
              <br />
              Beyond work, I find inspiration in:
              <ul>
              <li><b className="purple">Chess Enthusiast</b> — I enjoy the strategic thrill of chess and love competing in friendly matches. ♟️</li>
              <li><b className="purple">Tree Plantation</b> — Passionate about contributing to the environment by planting trees and spreading greenery. 🌱</li>
              <li><b className="purple">Travel & Adventure</b> — Exploring new places, cultures, and perspectives. 🌍</li>
            </ul>

            </p>
          </Col>
          <Col md={4} className="text-center">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social text-center">
            <h1>Let's Connect</h1>
            <p>Feel free to <span className="purple">reach out</span> and connect with me.</p>
            <ul className="home-about-social-links d-flex justify-content-center">
              <li className="social-icons">
                <a
                  href="https://github.com/Mohitbkd"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              {/*}
              <li className="social-icons">
                <a
                  href="https://x.com/awwyster"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              */}
              <li className="social-icons">
                <a
                  href="https://in.linkedin.com/in/mohit-bokade-832a92138"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/mohit_bokade_/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
